import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1500Model } from "../kymw1500.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * マーク変換情報更新サービス
 * @export UpdateCwsIconConvService
 * @class UpdateCwsIconConvService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCwsIconConvService extends PlessJsonResponderSub<any> {
  model: KYMW1500Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCwsIconConvService
   */
  private getBody(): PlessRequest {
    const combinationList: {
      parameter: {
        MarkCode: string,
        MarkCodeBranch: string,
        IconConv: string
      }
    }[] = [];

    for (const item of this.model.cwsIconConvInfoListForView) {
      const index = combinationList.findIndex(data =>
        data.parameter.MarkCode === item.markCode &&
        data.parameter.MarkCodeBranch === item.markCodeBranch
      );
      if (index === -1) {
        combinationList.push({
          parameter: {
            MarkCode: item.markCode,
            MarkCodeBranch: item.markCodeBranch,
            IconConv: item.iconFileName
          }
        });
      } else {
        combinationList[index].parameter.IconConv += (',\n' + item.iconFileName);
      }
    }

    return new PlessRequest({
      update: [
        {
          MarkInfoList: {
            combination: combinationList
          }
        }
      ]
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateCwsIconConvService
   */
  execute(model: KYMW1500Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('updateCwsIconConv', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCwsIconConvService
   */
  success() {
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
